import {
    compareCompetitions,
    sortCompetitionsFormula,
    sortLevelKeys,
} from "./competitionSort";

// All competition ordering now flows through the canonical FLC-47 comparator
// in competitionSort.js. These wrappers keep the existing call-site API.

export const sortLevels = (levelData) => {
    // Reorder the { levelName: [...] } map keys by canonical level order.
    return sortLevelKeys(levelData);
};

export const sortLevelData = (levelData) => {
    // levelData: [{ _id: level, competitions: [...] }]. Comps within one level
    // share that level, so the comparator's within-level rules apply.
    levelData?.forEach(item => {
        item?.competitions?.sort(compareCompetitions);
    });
    return levelData;
};

export const sortCompetitions = (competitions) => {
    competitions?.sort(compareCompetitions);
    return competitions;
};

export const groupAndSortComp = (competitions, isDesc) => {
    const sortedComp = sortCompetitionsFormula(competitions);
    if (isDesc) {
        sortedComp.reverse();
    }
    return sortedComp;
};

export const sortGrades = (grades) => {
    grades?.sort((a, b) => {
        let numA = extractNumber(a.grade_name);
        let numB = extractNumber(b.grade_name);

        if (isNaN(numA) && isNaN(numB)) {
            return a.grade_name.localeCompare(b.grade_name);
        }
        if (isNaN(numA)) return 1;
        if (isNaN(numB)) return -1;
        return numA - numB;
    });

    function extractNumber(grade_name) {
        let match = grade_name.match(/\d+/);
        if (match) {
            return parseInt(match[0]);
        }
        return NaN;
    }

    return grades
}
